export const ANALYTICS_VIEW = 'ANALYTICS_VIEW';
